"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWSCommon = void 0;
const core_services_1 = require("@iotv/core-services");
const ModelCommon_1 = require("../ModelCommon");
const { projectCode, stage } = process.env;
const getAWSTypeFromArn = (ob) => {
    let type = 'AWSCommmon';
    const arnParts = (0, core_services_1.getArnParts)(ob.arn);
    if (arnParts) {
        const { partition, service, region, accountId, resource, instance, suffix1, suffix2, suffix3 } = arnParts;
        let Service = 'Unknown';
        if (service) {
            Service = service.at(0)?.toUpperCase() + service.slice(1);
        }
        let Resource = 'Unknown';
        if (resource) {
            Resource = resource.at(0)?.toUpperCase() + resource.slice(1);
        }
        type = `${Service}${Resource}`;
    }
    return type;
};
class AWSCommon extends ModelCommon_1.ModelCommon {
    constructor({ ...ob }) {
        super(getAWSTypeFromArn(ob), { ...ob });
        this.arn = ob.arn;
        const arnParts = (0, core_services_1.getArnParts)(ob.arn);
        const { partition, service, region, accountId, resource, instance, suffix1, suffix2, suffix3 } = arnParts ?? {};
        const name = instance?.replace(new RegExp(`${projectCode}-${stage}-`), '') ?? 'Unknown';
        const id = instance ?? 'unknown';
        const key = `${this.type}:${id}`;
        this.sk = key;
        this.pk = key;
        this.id = id;
        this.name = name;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            arn: {
                type: 'String',
                editable: false,
            },
        };
    }
}
exports.AWSCommon = AWSCommon;
